import { gql } from "@apollo/client";

export const CustomerLoginMutation = gql`
    mutation($input: customerLoginInput!){
    verifyCustomerPin(input: $input) {
        message
        response
    }
    }
`;